// import ListItem from "@mui/material/ListItem";
import '../../components/AppLoader/AppLoader';
import '../../components/AppRoadMap/AppRoadMap.scss';
import './Api.scss';
import './ApiJSON.scss';
import './GettingStartedOverview/GettingStartedOverview.scss';
import { apiSublevels } from './navInfo';
import { Button, Skeleton, Typography } from '@mui/material';
import React, {
  CSSProperties,
  ReactNode,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState
} from 'react';
import { styled, useTheme } from '@mui/material/styles';
import { useAdobeAnalytics } from '../../providers/AdobeAnalytics';
import { useLocation, useNavigate, useNavigationType } from 'react-router-dom';
import { useSkipLink } from '../../providers/SkipLinkProvider';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import appContentParser from '../../components/AppContentParser/AppContentParser';
import AppLoader from '../../components/AppLoader/AppLoader';
import AppRoadMap from '../../components/AppRoadMap/AppRoadMap';
import QuarterDetails from '../../components/AppRoadMap/QuarterDetails/QuarterDetails';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Drawer from '@mui/material/Drawer';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FrenchDisclaimer from '../../components/FrenchDisclaimer/FrenchDisclaimer';
import GettingStartedOverview from './GettingStartedOverview/GettingStartedOverview';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import NDCapis from '../../components/NDCapis/NDCapis';
import ReleaseNotes from '../../components/ReleaseNotes/ReleaseNotes';
import PointOfSaleCoverage from '../../components/PointOfSaleCoverage/PointOfSaleCoverage';
import useHandleAnchorClick from '../../hooks/useHandleAnchorClick';
import useMediaQuery from '@mui/material/useMediaQuery';
import useScrollPosition from '../../hooks/useScrollPosition';
import useWindowSize from '../../assets/customHooks/useWindowSize';
import ApiDocTabs from '../../components/ApiDocTabs/ApiDocTabs';
import AccordionsPage from '../../components/AccordionsPage/AccordionsPage';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import { useDispatch, useSelector } from 'react-redux';
import {
  setClickedReleaseItem,
  setReleaseNotesAccordionActive,
  setReleaseNoteTitle,
  setShowReleaseDetails
} from '../../redux/slices/staticPagesSlice';
import { cleanDetailsLink } from '../../constants/apiUtil';

let width = window.innerWidth;
let drawerWidth = width > 500 ? 320 : width - 10; //This is super basic and should be updated...

const Main = styled('main', {
  shouldForwardProp: (prop) => prop !== 'open' && prop !== 'mobile'
})<{
  //MUI code for persistent drawer (I.e. the API Info Navigator)
  open?: boolean;
  mobile?: boolean;
}>(({ theme, open, mobile }) => ({
  flexGrow: 1,
  minWidth: 0,
  marginLeft: mobile ? 0 : `-${drawerWidth}px`,
  ...(open && !mobile && {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen
    }),
    marginLeft: 0
  }),
  padding: theme.spacing(3),
  transition: theme.transitions.create('margin', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen
  })
}));

export default function PersistentDrawerLeft({
  logoHeight,
  announcementBanner,
  isFooterNavigation
}) {
  const [alertMessage, setAlertMessage] = useState<string>('');
  const [content, setContent] = useState<ReactNode | null>();
  const [currLabel, setCurrLabel] = useState('');
  const [currLinks, setCurrLinks] = useState<any | null>(null);
  const [nonStanApiRef, setNonStanApiRef] = useState<any | null>([]);
  const [nonStanApiRefSubs, setNonStanApiRefSubs] = useState<any | null>([]);
  const [open, setOpen] = useState(
    !window.location.href.includes('/api/gettingstarted/gettingstarted')
  );

  const [openLinks, setOpenLinks] = useState(['']);
  const [openSections, setOpenSections] = useState(['']);
  const [sectionLinks, setSectionLinks] = useState({});
  const [showAppLoader, setShowAppLoader] = useState<boolean>(true);
  const [subNavs, setSubNavs] = useState(new Map());
  const [userClosedApiNav, setUserClosedApiNav] = useState(false);
  const [selectedApiDocTab, setSelectedApiDocTab] = useState<any | null>(null);
  const [showFrDisclaimer, setShowFrDisclaimer] = useState<boolean>(false);

  const location = useLocation();

  const {
    showReleaseDetails,
    releaseNoteTitle,
    clickedReleaseItem,
    reset,
    pageReload,
    releaseNotesAccordionActive
  } = useSelector((state: any) => state.staticPages);
  const dispatch = useDispatch();

  const { t, i18n } = useTranslation();

  const bodyHeader = useRef(null);
  const theme = useTheme();
  const mainRef = useRef(null) as any;
  const mobile = useMediaQuery(theme.breakpoints.down('md'));
  const navType = useNavigationType();
  const scrollPosition = useScrollPosition();
  const size = useWindowSize();
  const url = new URL(document.URL);
  const [apiVersionNew, setApiVersionNew] = useState(() => window.location.pathname.includes('/25.1'));
  const apiVersionNewRef = useRef(apiVersionNew);

  useEffect(() => {
    apiVersionNewRef.current = apiVersionNew;
  }, [apiVersionNew]);

  const handleApiVersionChange = useCallback(() => {
    setApiVersionNew(prev => !prev)
  }, [])

  const apiSortOrder = [
    {
      name: 'airshopping',
      drupalResponseIndex: 0
    },
    {
      name: 'offerprice',
      drupalResponseIndex: 1
    },
    {
      name: 'seatavailability',
      drupalResponseIndex: 4
    },
    {
      name: 'servicelist',
      drupalResponseIndex: 5
    },
    {
      name: 'ordercreate',
      drupalResponseIndex: 2
    },
    {
      name: 'orderretrieve',
      drupalResponseIndex: 6
    },
    {
      name: 'orderreshop',
      drupalResponseIndex: 3
    },
    {
      name: 'ordercancel',
      drupalResponseIndex: 7
    },
    {
      name: 'orderchange',
      drupalResponseIndex: 8
    },
    {
      name: 'orderchangenotification',
      drupalResponseIndex: 9
    },
    {
      name: 'scenario',
      drupalResponseIndex: 10
    }
  ];
  const apiDocTabsDocs = useMemo(() => {
    const all = t(
      apiVersionNew
        ? 'api_documentation_25_1_api_document'
        : 'api_documentation_api_document',
      { returnObjects: true, defaultValue: [] }
    ) as any;
    if (!Array.isArray(all)) return [];
    return apiSortOrder
      .map((api) => ({ doc: all[api.drupalResponseIndex], slug: api.name }))
      .filter((x) => !!x.doc)
      .map((x) => {
        const doc = { ...x.doc, route_slug: x.slug };
        const fc = doc.functional_capabilities;
        if (apiVersionNew && Array.isArray(fc) && fc[0]?.accordions?.length) {
          const [first, ...rest] = fc[0].accordions;
          doc.functional_capabilities = [
            { ...fc[0], introduction: first.details, accordions: rest },
            ...fc.slice(1)
          ];
        }
        return doc;
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [t, i18n.language, apiVersionNew]);
  const isAPIdocPg = currLinks && currLinks[0] === 'documentation';

  const { adobeAnalyticsSectionClick } = useAdobeAnalytics();
  const { navigationChange, setNavigationChange, setSideNav, setSkipLinks } =
    useSkipLink();

  const handleAnchorClick = useHandleAnchorClick();
  const navigate = useNavigate();

  /* Make API Navigator reponsive */
  if (size.width && size.width < 700 && size.width > 600) {
    drawerWidth = size.width / 2;
  } else if (size.width && size.width < 600) {
    drawerWidth = size.width;
  } else {
    drawerWidth = 320;
  }

  const checkClass = (levels: string[]) => {
    if (currLinks) {
      /*TEMP bug fix for latestrelease link not highlighting in nav... FIX properly (i.e. remove latestrelease as an option) when deal w/ page scrolling*/
      if (currLinks.includes('latestrelease')) {
        const temp = [...levels, 'latestrelease'];
        if (JSON.stringify(temp) === JSON.stringify(currLinks)) {
          return 'apiActive';
        }
      }
      /*end temp bugfix*/
      if (JSON.stringify(levels) === JSON.stringify(currLinks)) {
        return 'apiActive';
      } else if (currLinks.length > levels.length) {
        return levels.every((l, i) => l === currLinks[i])
          ? 'apiChildActive'
          : 'apiInactive';
      }
      return 'apiInactive';
    }
  };

  const checkIfSpecialPg = () => {
    if (
      currLinks &&
      currLinks[0] === 'documentation' &&
      (!currLinks[1] || currLinks[1] === 'ndcapis')
    ) {
      //adds a class that hides header/change pg layout for NDC APIs pg
      return 'documentation introPg';
    } else if (
      currLinks &&
      currLinks[0] &&
      currLinks[1] &&
      currLinks[0] === 'gettingstarted' &&
      currLinks[1] === 'gettingstarted'
    ) {
      //adds a class that hides header/change pg layout for Getting Started pg
      return 'gettingstarted introPg';
    } else if (currLinks && currLinks[0] === 'roadmap') {
      //adds a class that hides the side nav for the Roadmap pg
      return 'roadmap introPg';
    }
    // else if(currLinks &&  currLinks[0] === "releasenotes"){
    //   return 'releasenotesPg'
    // }
  };

  const checkForClosedActiveNav = (section: string, openType) => {
    const pos = openType === openSections ? 0 : 1;
    if (openType && currLinks) {
      if (!openType.includes(section) && currLinks[pos] === section) {
        return 'closedSectionWithActiveChild';
      }
    }
  };

  /* Nav link helper functions */
  const createNavLink = (path: string[], condClass = '') => {
    const link = path[1];

    const isActive = condClass.includes('apiActive');
    const uniqueId = `nav-label-${path.join('-')}`;
    let fullLabel = getLinkTitle(path);
    if (path.length === 3 && path[0] && path[1]) {
      const parentSection = getLinkTitle([path[0]]);
      const parentLink = getLinkTitle([path[0], path[1]]);
      fullLabel = `${parentSection} | ${parentLink} ${fullLabel}`;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    fullLabel = `${fullLabel}${isActive ? ' | Air Canada NDC' : ''}`;

    const isActiveCurlinks = JSON.stringify(path) === JSON.stringify(currLinks);


    return (
      <li
        key={`${path[path.length - 1]}-l-i`}
        onClick={() => handleClick(path)}
        onKeyDown={(event) => handleKeyPress(event, path)}
        className={condClass}
      >
        <ListItemButton
          role="link"
          key={`${link}-l-i-b`}
          aria-current={isActiveCurlinks ? 'page' : undefined}
          sx={{
            '&:focus-visible': {
              zIndex: 1,
              outline: '2px solid black',
              outlineOffset: '2px',
            }
          }}
          {...(link === 'gettingstarted' && { ref: skipLinkRef })}
          aria-labelledby={uniqueId}
        >
          <ListItemText
            disableTypography
            key={`${link}-l-i-t`}
            primary={getLinkTitle(path)}
          />
        </ListItemButton>
      </li>

    );
  };

  const data: any[] = t('navigation', {
    returnObjects: true,
    defaultValue: []
  });
  const releaseNotesData: any[] = t('release_notes_array', {
    returnObjects: true,
    defaultValue: []
  });
  const allData: any =
    i18next.store.data?.[i18next.language]?.translation || {};

  const getApiDocNav = () => {
    if (data) {
      const apiNavData = getApiNavData();
      return apiNavData?.find((item) => item.link.route === 'documentation');
    }
  };

  const getApiNavData = () =>
    data &&
    data.filter(
      (x) =>
        x.link.menu_name === (apiVersionNew? 'api_info_25' : 'api_info' )&&
        x.link.enabled &&
        x.link?.show_on_left_nav !== false
    );

  /* Get body content from JSON */
  const getBodyContent = (links: string[]) => {
    if (allData && links.length) {
      if (links[0] === 'releasenotes') {
        setContent(<ReleaseNotes />); // release_notes_entries release-notes
      } else if (links[0] === 'documentation' && (links.length === 1 || (links.length === 2 && links[1] === 'ndcapis')) && data) {
        //API Documentation > NDC APIs landing page
        setContent(
          <NDCapis
            handleClick={handleClick}
            data={data}
            isFooterNavigation={isFooterNavigation}
            setApiVersionNew={handleApiVersionChange}
            apiVersionNew={apiVersionNew}
          />
        );
      } else if (
        links[0] === 'gettingstarted' &&
        links[1] === 'gettingstarted'
      ) {
        //Getting Started > Getting Started is not a basic JSON page, get component
        setContent(
          <GettingStartedOverview
            navOpen={open}
            isFooterNavigation={isFooterNavigation}
          />
        );
      } else if (links[0] === 'roadmap') {
        // Unreachable for rendering: the early-return above (before the
        // drawer/Main wrapper) already handles both /api/roadmap and
        // /api/roadmap/:year/:quarter standalone. Kept only so this
        // function's contract (setContent for every links[0]) stays
        // consistent if that early-return is ever removed.
        setContent(
          links.length >= 3 && links[1] && links[2] ? (
            <QuarterDetails year={links[1]} quarter={links[2]} />
          ) : (
            <AppRoadMap />
          )
        );
      } else if (links[1] === 'apisetup') {
        setContent(
          <AccordionsPage
            accordions={t('api_setup_accordions', {
              returnObjects: true,
              defaultValue: []
            })}
          />
        );
      } else if (links[1] === 'sellersetup') {
        setContent(
          <AccordionsPage
            accordions={t('seller_setup_accordions', {
              returnObjects: true,
              defaultValue: []
            })}
          />
        );
      } else if (links[1] === 'testdata') {
        setContent(
          <AccordionsPage
            accordions={t('test_data_accordions', {
              returnObjects: true,
              defaultValue: []
            })}
          />
        );
      } else if (links[0] === 'pointOfSaleCoverage') {
        const transformPOSData = (input, original) => {
          const parseCountry = (countryStr) => {
            const match = countryStr.match(/^(.+?)\s*\((\w+)\)$/);
            return match
              ? { name: match[1].trim(), code: match[2] }
              : { name: countryStr, code: '' };
          };

          const supportedMarketTypes = input.pos_map_supported_markets.map(
            (marketType) => ({
              title: marketType.payment_method_settlement.replace(/,\s*$/, ''),
              markets: marketType.markets.map((market) => {
                const { name, code } = parseCountry(market.country);
                return {
                  name: name,
                  code: code,
                  tooltip: market.launch
                };
              })
            })
          );

          const upcomingMarkets = input.pos_map_upcoming_markets.flatMap(
            (marketType) =>
              marketType.markets.map((market) => {
                const { name, code } = parseCountry(market.country);
                return {
                  name: name,
                  code: code,
                  tooltip: market.launch
                };
              })
          );

          return {
            ...original,
            supportedMarkets: {
              ...original.supportedMarkets,
              market_types: supportedMarketTypes
            },
            upcomingMarkets: {
              ...original.upcomingMarkets,
              markets: upcomingMarkets
            }
          };
        };

        setContent(
          <PointOfSaleCoverage
            data={transformPOSData(
              {
                pos_map_header_title: t('pos_map_header_title', {
                  returnObjects: true,
                  defaultValue: ''
                }),
                pos_map_supported_markets: t('pos_map_supported_markets', {
                  returnObjects: true,
                  defaultValue: []
                }),
                pos_map_upcoming_markets: t('pos_map_upcoming_markets', {
                  returnObjects: true,
                  defaultValue: []
                })
              },
              t('point_of_sale', { returnObjects: true, defaultValue: {} })
            )}
          />
        );
      } else if (links[1] === 'apisorchestration') {
        setContent(
          <AccordionsPage
            accordions={t('api_orchestration_accordions', {
              returnObjects: true,
              defaultValue: []
            })}
          />
        );
      } else {
        appContentParser({
          links,
          data: allData,
          setContent,
          handleAnchorClick
        });
      }
    } else {
      if (!links.length) {
        console.log('No links loaded - Redirect to Getting Started > Intro');
        handleClick(['gettingstarted', 'gettingstarted']);
      } else {
        console.log('No data loaded');
      }
    }
  };

  const getHeaderFontSize = (content?: string) => {
    //check if header can fit on one line, if not, make it responsive (can't just wrap because of potential fixed tab menu underneath...)
    const availableHeaderSpace = open
      ? window.innerWidth - 400
      : window.innerWidth - 50;
    const headerLength = content?.length || 1;

    let getFS = '';
    if (availableHeaderSpace / headerLength < 12) {
      //Long title, make responsive text
      getFS = 'calc(100% + 1vw)';
    } else {
      getFS = mobile ? '24px' : '28px';
    }
    return getFS;
  };

  const getLinkTitle = (path: string[]) => {
    if (data) {
      const apiNavData = getApiNavData();

      let usePath = [''];

      if (path.length > 1 && path[0] === 'documentation') {
        if (path.length === 2) {
          usePath = path;
        } else {
          //Check for default API Documentation sublevel nav items or custom
          const ApiDocNav = getApiDocNav();
          const checkIfDefaults = ApiDocNav['link']['subtree'].find(
            (x) => x.link.route === path[1]
          );

          if (
            checkIfDefaults.link.has_children &&
            checkIfDefaults.link.default_children
          ) {
            //Is a default nav item
            return ApiDocNav['link']['default_sub_children'][path[2]];
          } else if (checkIfDefaults.link.has_children) {
            //Is a custom item
            const customApiDocSubTitle = checkIfDefaults.link.subtree.find(
              (x) => x.link.route === path[2]
            );
            if (customApiDocSubTitle?.link) {
              return customApiDocSubTitle?.link.title;
            } else {
              return 'Error finding link';
            }
          }
        }
      } else {
        usePath = path;
      }
      if (
        usePath.length === 2 &&
        usePath[0] === 'releasenotes' &&
        usePath[1] !== 'latestrelease'
      ) {
        return usePath[1];
      }

      let navSteps = '';
      let title = 'Error finding link';
      usePath.forEach((step, i) => {
        const latestLevel: any = navSteps === '' ? apiNavData : navSteps;
        const updateSteps = latestLevel.find(
          (item) => item.link.route === step
        );
        if (updateSteps) {
          if (i < usePath.length - 1) {
            if (updateSteps['link']['subtree']) {
              navSteps = updateSteps['link']['subtree'];
            }
          } else {
            title = updateSteps['link']['title'];
          }
        }
      });

      return title;
    }
  };

  const getNonStanApiDoc = () => {
    //Most API Documentation links have the same subs (Functionality, Request, etc),
    //but find those that don't and get their sublinks, if applicable
    if (data) {
      const apiDocNav = getApiDocNav();
      const arrNonStanApiRef: string[] = [];
      const temp = { documentation: {} };

      apiDocNav.link.subtree?.forEach((x) => {
        if (!x.link.default_children) {
          arrNonStanApiRef.push(x.link.route);
        }
        if (!x.link.default_children && x.link.has_children) {
          const arrNonStanApiRefSubs: string[] = [];
          x.link.subtree.forEach((sub) => {
            arrNonStanApiRefSubs[sub.link.weight - 1] = sub.link.route;
          });
          temp['documentation'][x.link.route] = arrNonStanApiRefSubs;
        }
      });
      setNonStanApiRef(arrNonStanApiRef);
      setNonStanApiRefSubs(temp);
    }
  };

  const getSectionLinks = () => {
    const apiNavData = getApiNavData();
    let sectionLinks = {};

    apiNavData.forEach((item) => {
      if (item.link.has_children) {
        item.link.subtree?.forEach((x) => {
          if (x.link.enabled) {
            sectionLinks[item.link.route]
              ? sectionLinks[item.link.route].splice(
                x.link.weight - 1,
                0,
                x.link.route
              )
              : (sectionLinks[item.link.route] = [x.link.route]);
          }
        });
      } else {
        sectionLinks[item.link.route] = [];
      }
    });

    generateHierarchy(sectionLinks);
  };

  const releaseNotesDataRef = useRef<any[]>(releaseNotesData);

  React.useEffect(() => {
    if (releaseNotesData.length) {
      releaseNotesDataRef.current = releaseNotesData;
    }
  }, [releaseNotesData]);

  const labelMap = {
    fr: {
      releaseNotifications: 'Avis de mise à jour',
      environments:
        'Vous trouverez ci-dessous les dates prévues des améliorations à nos différents environnements :',
      overView: 'Aperçu',
      messages: 'Exemples de messages',
      affected: 'API touchées',
      scope: 'Hors du champ d’application',
      limitations: 'Restrictions'
    },
    en: {
      releaseNotifications: 'Release Notifications',
      environments:
        'Below are the scheduled dates for enhancements in our different environments:',
      overView: 'Overview',
      messages: 'Sample Messages',
      affected: 'APIs Affected',
      scope: 'Out of Scope',
      limitations: 'Limitations'
    }
  };

  const currentLanguage = i18n.language || 'en';
  const overView = labelMap[currentLanguage].overView;
  const messages = labelMap[currentLanguage].messages;
  const affected = labelMap[currentLanguage].affected;

  const generateHierarchy = (sectionLinks = {}) => {
    if (showReleaseDetails) {
      if (clickedReleaseItem?.length && releaseNotesDataRef.current?.length) {
        const detailReleaseNote = releaseNotesDataRef.current.reduce(
          (acc, item) => {
            if (acc) return acc;
            const entry = item.entries.find((entry) => {
              return (
                decodeURIComponent(cleanDetailsLink(entry.title.trim())) ===
                cleanDetailsLink(releaseNoteTitle)
              );
            });
            return entry ? entry : acc;
          },
          null
        );

        if (detailReleaseNote) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(
            detailReleaseNote.detailsBody,
            'text/html'
          );
          const h3Elements = doc.querySelectorAll('h3');

          let nestedHeadings = Array.from(h3Elements).map((h3: any) => {
            const h4s: any = [];
            let nextSibling: any = h3.nextElementSibling;
            while (nextSibling && nextSibling.tagName !== 'H3') {
              if (nextSibling.tagName === 'H4') {
                h4s.push(nextSibling.textContent);
              }
              nextSibling = nextSibling.nextElementSibling;
            }
            return {
              h3: h3.textContent,
              h4s: h4s
            };
          });
          if (detailReleaseNote?.overview?.length) {
            nestedHeadings.unshift({ h3: overView, h4s: [] });
          }
          if (
            detailReleaseNote?.sample_message_upload ||
            detailReleaseNote?.xmlSampleFiles
          ) {
            nestedHeadings.push({ h3: messages, h4s: [] });
          }

          if (detailReleaseNote?.services?.length) {
            nestedHeadings.push({ h3: affected, h4s: [] });
          }

          nestedHeadings = [
            { h3: detailReleaseNote?.title, h4s: [] },
            ...nestedHeadings
          ];

          const searchParams = window.location.search
            ?.split('?')
            .filter(Boolean);
          if (searchParams.length > 2) {
            // dispatch(setReleaseNotesAccordionActive([`${nestedHeadings[0].h3}-${searchParams[1]}-false`.replace(/ /g, '-').toLowerCase()]));
          }

          if (!sectionLinks['releasenotes']?.length && nestedHeadings.length) {
            setSectionLinks((prevState) => ({
              ...prevState,
              ...sectionLinks,
              releasenotes: nestedHeadings
            }));
          }
        }
      }
    } else {
      setSectionLinks((prevState) => ({
        ...prevState,
        ...sectionLinks
      }));
    }
  };

  React.useEffect(() => {
    generateHierarchy();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    showReleaseDetails,
    openLinks,
    releaseNoteTitle,
    clickedReleaseItem,
    location.search
  ]);

  React.useEffect(() => {
    if (!showReleaseDetails) {
      setCurrLinks(['releasenotes']);
      dispatch(setClickedReleaseItem(''));
      setSectionLinks({
        ...sectionLinks,
        releasenotes: []
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showReleaseDetails]);

  React.useEffect(() => {
    if (reset) {
      setCurrLinks(['releasenotes']);
      setSectionLinks({
        ...sectionLinks,
        releasenotes: []
      });
      // dispatch(setResetAllReleaseItems())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reset]);

  const getShowHideBttnTxt = (vs: string) => {
    if (data) {
      const ApiDocNav = getApiDocNav();
      return ApiDocNav['link']['show_hide_button'][vs];
    }
  };

  /* Handle clicks */
  const handleClick = (links: string[], keyboard = false) => {
    if (!showReleaseDetails) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    if (data) {
      if (links.length === 1) {
        trackOpenMenuSections(links, 0);
      } else if (links.length === 2) {
        trackOpenMenuLinks(links, 1);
      }

      setCurrLinks(links);

      getBodyContent(links);

      adobeAnalyticsSectionClick('side nav');
      if (links[0] !== 'releasenotes') {
        setSectionLinks((prevState) => ({
          ...prevState,
          releasenotes: []
        }));
        dispatch(setClickedReleaseItem(''));
        dispatch(setShowReleaseDetails(false));
        dispatch(setReleaseNoteTitle(''));
      }
      if (links[0] === 'releasenotes') {
        dispatch(setClickedReleaseItem(links[1]));
        !openLinks.includes(links[1]) &&
          dispatch(setReleaseNotesAccordionActive([]));
        links = links.map((link) => cleanDetailsLink(link.trim()));

        const nestedHeadings = sectionLinks['releasenotes'];

        if (links[1] === cleanDetailsLink(nestedHeadings[0]?.h3?.trim())) {
          window.history.pushState(
            {},
            '',
            `/${i18n.language}/api/releasenotes?${links[1]}`
          );
        } else {
          const h3Tag = nestedHeadings.find(
            (heading) =>
              cleanDetailsLink(heading.h3?.trim()) === links[1].toLowerCase() ||
              heading.h4s.some(
                (h4) => cleanDetailsLink(h4?.trim()) === links[1].toLowerCase()
              )
          );
          const retrieveParentSearch = cleanDetailsLink(
            nestedHeadings[0]?.h3?.trim()
          );
          if (h3Tag) {
            const path =
              h3Tag.h4s.length === 0
                ? `/${i18n.language}/api/releasenotes?${retrieveParentSearch}?${links[1]}`
                : `/${i18n.language
                }/api/releasenotes?${retrieveParentSearch}?${cleanDetailsLink(
                  h3Tag.h3?.trim()
                )}?${links[1]}`;
            window.history.pushState({}, '', decodeURIComponent(path));
          } else {
            let fullLink = `/${i18n.language}/api`;
            links.map((link) => (fullLink = `${fullLink}/${link}`));
            const url = new URL(document.URL);
            url.pathname !== fullLink && navigate(`${fullLink}`);
          }
        }
      } else {
        //update route
        const version = apiVersionNewRef.current ? '25.1' : '17.2';
        const linksWithoutDoc = links.filter(l => l !== 'documentation' && l !== 'ndcapis');
        const subPath = linksWithoutDoc.join('/');
        const fullLink = links[0] === 'documentation'
          ? `/${i18n.language}/api/documentation/ndcapis/${version}${subPath ? '/' + subPath : ''}`
          : `/${i18n.language}/api/${links.join('/')}`;
        const url = new URL(document.URL);
        url.pathname !== fullLink && navigate(`${fullLink}`);
        openMenus(links);
      }

      if (mobile) {
        //check for last level nav click, if so, close mobile menu automatically
        const depth = links.length;
        const checkDepth3 = depth === 3;
        const checkDepth2 = depth === 1 && sectionLinks[links[0]]?.length === 0;
        const checkDepth1 =
          depth === 2 &&
          ((links[0] !== 'documentation' && !nonStanApiRefSubs[links[1]]) ||
            links[0] === 'documentation');

        if (checkDepth1 || checkDepth2 || checkDepth3) {
          handleDrawerClose();
        }
      }
      if (keyboard) {
        mainRef?.current?.focus();
      }
    }
  };

  const handleDrawerOpen = () => {
    setOpen(true);
    setUserClosedApiNav(false);
    setSideNav({ open: () => handleDrawerOpen(), isOpen: true });
  };

  const handleDrawerClose = () => {
    setOpen(false);
    setUserClosedApiNav(true);
    setSideNav({ open: () => handleDrawerOpen(), isOpen: false });
  };

  const handleDropDownOpen = (links: string[]) => {
    if (links.length === 1) {
      trackOpenMenuSections([links[0]], 0);
    } else {
      trackOpenMenuLinks(links, 1);
    }
  };

  const handleDropDownOpenPress = (event, links: string[]) => {
    if (event.which === 13) {
      handleDropDownOpen(links);
    }
  };

  const handleKeyPress = (event, links: string[]) => {
    if (event.which === 13) {
      handleClick(links, true);
    }
  };

  const handleKeyPressDrawer = (event) => {
    if (event.which === 13) {
      setOpen(!open);
    }
  };

  /* Helper functions for getting all Nav info from JSON */
  const openMenus = (path: string[]) => {
    if (path.length === 1) {
      //is a top section route
      setOpenSections([...openSections, path[0]]);
    } else if (path.length < 4) {
      //is a link or sublink route NOTE: if more route levels added, need to add a case increase for each...
      setOpenSections([...openSections, path[0]]);
      setOpenLinks([...openLinks, path[1]]);
    }
  };

  /* Track open menu sections*/
  const trackOpenMenuLinks = (links: string[], pos: number) => {
    if (openLinks.includes(links[pos])) {
      setOpenLinks(openLinks.filter((e) => e !== links[pos]));
    } else {
      setOpenLinks([...openLinks, links[pos]]);
    }
  };

  const trackOpenMenuSections = (links: string[], pos: number) => {
    if (openSections.includes(links[pos])) {
      setOpenSections(openSections.filter((e) => e !== links[pos]));
    } else {
      setOpenSections([...openSections, links[pos]]);
    }
  };

  const skipLinkRef = useCallback((node) => {
    if (node !== null) {
      setSkipLinks((prev) => {
        let index = prev.findIndex((item) => item.id === 1);
        return [
          ...prev.slice(0, index),
          { ...prev[index], ref: node },
          ...prev.slice(index + 1)
        ];
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setSideNav({ open: () => handleDrawerOpen(), isOpen: open });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let links = url.pathname.split('/');

        // Detect version from URL on direct access
    const urlVersion = links.includes('25.1') ? '25.1' : '17.2';
    const isV25FromUrl = urlVersion === '25.1';


    // Detect version from URL on direct access
    if (links.includes('25.1') && !apiVersionNew) {
      setApiVersionNew(true);
    } else if (links.includes('17.2') && apiVersionNew) {
      setApiVersionNew(false);
    }

    links = links.filter(
      (link) => link !== 'api' && link !== i18n.language && link !== '' && link !== '17.2' && link !== '25.1' && link !== 'ndcapis'
    );

  // If URL targets a specific API or sublevel under documentation, validate it exists
    // for the detected version; if not, redirect to the base version URL
    if (data && links[0] === 'documentation' && links.length >= 2) {
      const versionNavData = data.filter(
        (x: any) =>
          x.link.menu_name === (isV25FromUrl ? 'api_info_25' : 'api_info') &&
          x.link.enabled &&
          x.link?.show_on_left_nav !== false
      );
      const apiDocNav = versionNavData?.find((item: any) => item.link.route === 'documentation');
      const apiName = links[1];

      if (apiDocNav && apiName) {
        const apiEntry = apiDocNav.link.subtree?.find(
          (x: any) => x.link.route === apiName && x.link.enabled !== false
        );

        if (!apiEntry) {
          // API does not exist for this version — redirect to base version URL
          navigate(`/${i18n.language}/api/documentation/ndcapis/${urlVersion}`);
          return;
        }

        // Validate sublevel if present
        if (links.length > 2 && links[2]) {
          const subName = links[2];
          let subExists = false;
          if (!apiEntry.link.has_children || apiEntry.link.default_children) {
            subExists = apiSublevels.includes(subName);
          } else {
            subExists = apiEntry.link.subtree?.some((sub: any) => sub.link.route === subName);
          }
          if (!subExists) {
            navigate(`/${i18n.language}/api/documentation/ndcapis/${urlVersion}`);
            return;
          }
        }
      }
    }
    
    // Normalize: treat ['documentation'] as the NDC APIs landing page so the nav item highlights correctly
    if (links.length === 1 && links[0] === 'documentation') {
      links = ['documentation', 'ndcapis'];
    }

    setCurrLinks(links);
    getBodyContent(links);
    openMenus(links);

    if (
      mobile ||
      window.location.href.includes('/api/gettingstarted/gettingstarted')
    ) {
      //if on mobile OR on Getting Started page close api nav by default
      setOpen(false);
    } else if (!userClosedApiNav) {
      //catch if navigator only closed b/c visited Getting Started pg...
      setOpen(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url.pathname]);

  useEffect(() => {
    //On initial load, get data, loop through JSON for content and nav creation...
    if (data || navType === 'POP') {
      const sublinks = new Map();

      for (const [key, value] of Object.entries(nonStanApiRefSubs)) {
        if (key && value) {
          for (const [key2, value2] of Object.entries(value)) {
            sublinks.set(`${key}.${key2}`, value2);
          }
        }
      }

      setSubNavs(sublinks);
      getSectionLinks();
      getNonStanApiDoc();

      // if (
      //   !userClosedApiNav &&
      //   !window.location.href.includes("/api/gettingstarted/gettingstarted")
      // ) {
      //   setOpen(true);
      // }
      setShowAppLoader(false);
    } else {
      setShowAppLoader(true);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navType, apiVersionNew]);

  /* Set page title */
  useEffect(() => {
    if (currLinks?.length) {
      let header = '';
      if (
        currLinks.length === 3 &&
        currLinks[0] === 'documentation' &&
        apiSublevels.includes(currLinks[2])
      ) {
        //If is API ref sub so only go to 2nd path level (I.e. don't display Functionality, Response, etc)
        header = getLinkTitle([currLinks[0], currLinks[1]]);
      } else {
        header = getLinkTitle(currLinks);
      }

      if (currLinks.length === 3 && currLinks[0] === 'documentation') {
        const api = apiSortOrder.find((api) => api.name === currLinks[1]);
        if (api) {
          const { drupalResponseIndex: selectedApiIndex } = api;
          if (selectedApiIndex !== -1) {
            setSelectedApiDocTab(
              apiVersionNew ? t('api_documentation_25_1_api_document', {
                returnObjects: true,
                defaultValue: []
              })[selectedApiIndex] : t('api_documentation_api_document', {
                returnObjects: true,
                defaultValue: []
              })[selectedApiIndex]
            );
          } else {
            setSelectedApiDocTab(null);
          }
        } else {
          setSelectedApiDocTab(null);
        }
      } else {
        setSelectedApiDocTab(null);
      }
      if (typeof header === 'string' && !header.includes('undefined')) {
        if (window.location.pathname?.toLowerCase().includes('releasenotes')) {
          header =
            t('sellerProfile.dashboard.NT001', { defaultValue: undefined }) ||
            header;
        }
        setCurrLabel(header);
      }
    }

    document.querySelectorAll('[role="region"]').forEach(function (el) {
      const label =
        el.parentElement?.parentElement?.parentElement?.previousElementSibling
          ?.firstChild?.textContent || '';
      if (!el.ariaLabel) {
        el.ariaLabel = `${label} section`;
      }
    });
    if (navigationChange) {
      setNavigationChange(false);
      const page =
        currLinks.length === 3
          ? `${currLinks[1]} ${currLinks[2]}`
          : currLinks[currLinks.length - 1];
      setAlertMessage(`Page changed to ${page}`);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currLinks]);

  // Reflect API version in URL after navigation settles
  useEffect(() => {
    if (currLinks?.[0] === 'documentation') {
      const version = apiVersionNew ? '25.1' : '17.2';
      const cleanLinks = currLinks.filter((link: string) => link !== '17.2' && link !== '25.1' && link !== 'ndcapis');
      const subPath = cleanLinks.slice(1).join('/');
      const versionedPath = subPath
        ? `/${i18n.language}/api/documentation/ndcapis/${version}/${subPath}`
        : `/${i18n.language}/api/documentation/ndcapis/${version}`;
      if (window.location.pathname !== versionedPath) {
        window.history.replaceState({}, '', versionedPath);
      }
    }
  }, [currLinks, apiVersionNew, i18n.language]);

  // Handle normal navigation
  useEffect(() => {
    if (
      window.location.pathname?.toLowerCase().includes('releasenotes') &&
      !pageReload
    ) {
      if (releaseNoteTitle) {
        // Normal navigation: Open the release notes section
        setOpenSections(['releasenotes', ...openSections]);

        setOpenLinks([
          'releasenotes',
          cleanDetailsLink(releaseNoteTitle.toLowerCase()?.trim())
        ]);
      } else if (releaseNoteTitle.length === 0) {
        // Close the release notes section
        setOpenSections(
          openSections.filter((section) => section !== 'releasenotes')
        );
        setOpenLinks([]);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [releaseNoteTitle]);

  // Handle page reloads
  useEffect(() => {
    if (
      window.location.search &&
      window.location.pathname?.toLowerCase().includes('releasenotes')
    ) {
      // Page reload: Handle the window.location.search
      const params = window.location.search
        .split('?')
        .filter(Boolean)
        .map((item) => decodeURIComponent(item));
      setOpenLinks([...params]);
      setOpenSections(['releasenotes', ...openSections]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location.search]);

  useEffect(() => {
    const [firstLink, secondLink] = currLinks || [];
    const shouldShow =
      i18n.language === 'fr' &&
      firstLink === 'documentation' &&
      secondLink !== 'ndcapis';
    setShowFrDisclaimer(shouldShow);
  }, [i18n.language, currLinks]);

  const langMap = {
    fr: {
      navigation: 'navigation latérale',
      content: 'contenu'
    },
    en: {
      navigation: 'side bar',
      content: 'content'
    }
  };
  const currentLangualge = i18n.language || 'en';
  const navigation = langMap[currentLangualge].navigation;


  const drawer = (
    // Do Section labels/links
    <nav id="apiLeftDrawer" aria-label={navigation}>
      {getApiNavData() &&
        getApiNavData().map((item) => {
          const section = item.link.route;

          if (
            (isAPIdocPg && section !== 'documentation') ||
            (!isAPIdocPg && section === 'documentation')
          )
            return false; //Now two seperate pages (general/documentation) so hide accordingly...

          if (
            (!sectionLinks[section] || sectionLinks[section].length === 0) &&
            (!showReleaseDetails || section !== 'releasenotes')
          ) {
            //Is a section with no links, so make it the link
            const linkLabel = getLinkTitle([section]);
            const checkActive = checkClass([section]);

            return (
              <Typography
                component="h2"
                sx={{
                  all: 'unset',
                  display: 'block'
                }}
              >
              <div
                role="link"
                className={`${checkActive} apiAccordionStyleShallow`}
                onClick={() => handleClick([section])}
                onKeyDown={(event) => handleKeyPress(event, [section])}
                key={`${section}-sectionbttn`}
                tabIndex={0}
              >
                {linkLabel}
              </div>
              </Typography>
            );
          } else {
            //Is a section with at least one level of links, make menu an accordion/dropdown

            return (
              <Accordion
                className="accordionStyle divide"
                disableGutters={true}
                key={`${section}-t-a`}
                expanded={openSections?.includes(section)}
                sx={{
                  '.MuiAccordionSummary-root': {
                    padding: '8px 18px !important',
                    '&:hover': {
                      backgroundColor: 'grey.100'
                    }
                  }
                }}
              >

                <Typography
                  component="h2"
                  sx={{
                    all: 'unset',
                    display: 'block'
                  }}
                >

                  <AccordionSummary

                    key={`${section}-t-a-s`}
                    aria-controls={`${section}-details`}
                    expandIcon={<ExpandMoreIcon aria-hidden="true" />}
                    onClick={() => handleDropDownOpen([section])}
                    onKeyDown={(event) =>
                      handleDropDownOpenPress(event, [section])
                    }
                    className={`accordionSummaryStyle ${checkClass([
                      section
                    ])} ${checkForClosedActiveNav(section, openSections)}`}
                    sx={{
                      fontWeight: 600,
                      '&:focus-visible': {
                        zIndex: 1,
                        outline: '2px solid black',
                        outlineOffset: '2px',
                      }
                    }}

                  >
                    {getLinkTitle([section])}
                  </AccordionSummary>
                </Typography>
                <AccordionDetails
                  key={`${section}-a-d`}
                  id={`${section}-details`}
                  className="accordionDetailsStyle"
                >
                  <List key={`${section}-l`}>
                    {(section === 'releasenotes'
                      ? ['']
                      : sectionLinks[section]
                    ).map((link: string) => {
                      try {
                        const addNavCondClass = `${checkClass([
                          section,
                          link
                        ])} apiLink`;
                        let currSublinks = [''];
                        let condClass = '';

                        if (
                          (section === 'documentation' &&
                            !nonStanApiRef.includes(link)) ||
                          subNavs.get(`${section}.${link}`)
                        ) {
                          //Link has a subnav, so create dropdown (accordion)
                          //NOTE: In 'API Documentation' section most links have same subnavs, others are from custom list

                          currSublinks =
                            section === 'documentation' &&
                              !nonStanApiRef.includes(link)
                              ? apiSublevels
                              : Array.from(subNavs.get(`${section}.${link}`));

                          if (link === 'orderchange') {
                            currSublinks = [
                              'functionality',
                              'request',
                              'response',
                              'usecases'
                            ];
                          } else if (link === 'orderchangenotification') {
                            currSublinks = ['functionality'];
                          } else if (link === 'scenario') {
                            currSublinks = ['usecases'];
                          }

                          condClass =
                            section === 'documentation'
                              ? 'apiLink'
                              : 'apiSubnav';

                          return (
                            <li key={`${link}-li`}>
                              <Accordion
                                className="accordionStyle"
                                disableGutters={true}
                                key={`${link}-a`}

                                sx={{
                                  '.MuiAccordionSummary-root': {
                                    padding: '8px 18px !important',
                                    '&:hover': {
                                      backgroundColor: 'grey.100'
                                    }
                                  }
                                }}
                              >

                                <Typography
                                  component="h3"
                                  sx={{
                                    all: 'unset',
                                    display: 'block'
                                  }}
                                >

                                  <AccordionSummary

                                    key={`${link}-a-s`}
                                    aria-controls={`${section}-${link}-details`}
                                    sx={{
                                      '&:focus-visible': {
                                        zIndex: 1,
                                        outline: '2px solid black',
                                        outlineOffset: '2px',
                                      }
                                    }}
                                    expandIcon={
                                      <ExpandMoreIcon
                                        aria-hidden="true"
                                        key={`${link}-exp`}
                                        onClick={() =>
                                          handleDropDownOpen([section, link])
                                        }
                                        onKeyDown={(event) =>
                                          handleDropDownOpenPress(event, [
                                            section,
                                            link
                                          ])
                                        }
                                      />
                                    }
                                    className={`accordionSummaryStyle ${condClass} ${checkForClosedActiveNav(
                                      link,
                                      openLinks
                                    )}`}
                                    onClick={() => {
                                      handleDropDownOpen([section, link]);
                                    }}
                                    onKeyDown={(event) => {
                                      handleDropDownOpenPress(event, [
                                        section,
                                        link
                                      ]);
                                    }}
                                  >
                                    {getLinkTitle([section, link])}
                                  </AccordionSummary>
                                </Typography>
                                <AccordionDetails id={`${section}-${link}-details`}>
                                  <List key={`${link}-k`}>
                                    {currSublinks.map((apiSub) => {
                                      const addSubNavCondClass = `${checkClass([
                                        section,
                                        link,
                                        apiSub
                                      ])} ${condClass} accordionDetailsStyle`;
                                      return createNavLink(
                                        [section, link, apiSub],
                                        addSubNavCondClass
                                      );
                                    })}
                                  </List>
                                </AccordionDetails>
                              </Accordion>
                            </li>
                          );
                        } else if (
                          section === 'releasenotes' &&
                          sectionLinks[section]?.length
                        ) {
                          //Link is in release notes section
                          const nestedHeadings = sectionLinks[section];
                          // if (nestedHeadings.length === 0) {
                          //   return
                          // }
                          return (
                            <li key={`${link}-li`}>
                              <Accordion
                                className="accordionStyle"
                                disableGutters={true}
                                key={`${link}-a`}
                                expanded={true}
                                sx={{
                                  '.MuiAccordionSummary-root': {
                                    padding: '8px 18px !important',
                                    '&:hover': {
                                      backgroundColor: 'grey.100'
                                    }
                                  }
                                }}
                              >
                                <List key={`${link}-k`} sx={{ pt: 0 }}>
                                  {nestedHeadings.map((heading) => {
                                    const addSubNavCondClass = `${checkClass([
                                      section,
                                      heading.h3?.trim()
                                    ])} apiLink`;
                                    if (heading.h4s.length > 0) {
                                      return (
                                        <li key={`${heading.h3}-li`}>
                                          <Accordion
                                            className="accordionStyle "
                                            disableGutters={true}
                                            key={`${heading.h3}-a`}
                                            onChange={(a, b) => {
                                              dispatch(
                                                setReleaseNotesAccordionActive(
                                                  b === false
                                                    ? [
                                                      ...releaseNotesAccordionActive,
                                                      decodeURIComponent(
                                                        cleanDetailsLink(
                                                          `${nestedHeadings[0].h3?.trim()}-${heading.h3?.trim()}-${b}`
                                                        )
                                                      )
                                                    ]
                                                    : releaseNotesAccordionActive.filter(
                                                      (i) =>
                                                        i !==
                                                        decodeURIComponent(
                                                          cleanDetailsLink(
                                                            `${nestedHeadings[0].h3?.trim()}-${heading.h3?.trim()}-${b}`
                                                          )
                                                        )
                                                    )
                                                )
                                              );
                                            }}
                                            expanded={openLinks?.includes(
                                              decodeURIComponent(
                                                cleanDetailsLink(
                                                  heading.h3?.trim()
                                                )
                                              )
                                            )}
                                            sx={{
                                              '.MuiAccordionSummary-root': {
                                                padding: '8px 18px !important',
                                                '&:hover': {
                                                  backgroundColor: 'grey.100'
                                                }
                                              }
                                            }}
                                          >
                                            <AccordionSummary
                                              key={`${heading.h3?.trim()}-a-s`}
                                              expandIcon={
                                                <ExpandMoreIcon
                                                  key={`${heading.h3?.trim()}-exp`}
                                                  onClick={() =>
                                                    handleDropDownOpen([
                                                      section,
                                                      decodeURIComponent(
                                                        cleanDetailsLink(
                                                          heading.h3?.trim()
                                                        )
                                                      )
                                                    ])
                                                  }
                                                  onKeyDown={(event) =>
                                                    handleDropDownOpenPress(
                                                      event,
                                                      [
                                                        section,
                                                        decodeURIComponent(
                                                          cleanDetailsLink(
                                                            heading.h3?.trim()
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  }
                                                />
                                              }
                                              className={`accordionSummaryStyle ${addSubNavCondClass} ${releaseNotesAccordionActive.includes(
                                                decodeURIComponent(
                                                  cleanDetailsLink(
                                                    `${nestedHeadings[0].h3?.trim()}-${heading.h3?.trim()}-false`
                                                  )
                                                )
                                              ) &&
                                                  heading.h4s
                                                    .map((i) =>
                                                      decodeURIComponent(
                                                        cleanDetailsLink(i)
                                                      )
                                                    )
                                                    .includes(
                                                      decodeURIComponent(
                                                        clickedReleaseItem
                                                      )
                                                    )
                                                  ? 'closedSectionWithActiveChild'
                                                  : ''
                                                }`}
                                              onClick={() => {
                                                handleDropDownOpen([
                                                  section,
                                                  decodeURIComponent(
                                                    cleanDetailsLink(
                                                      heading.h3?.trim()
                                                    )
                                                  )
                                                ]);
                                              }}
                                              onKeyDown={(event) => {
                                                handleDropDownOpenPress(event, [
                                                  section,
                                                  decodeURIComponent(
                                                    cleanDetailsLink(
                                                      heading.h3?.trim()
                                                    )
                                                  )
                                                ]);
                                              }}
                                            >
                                              {heading.h3?.trim()}
                                            </AccordionSummary>
                                            <List
                                              key={`${heading.h3?.trim()}-k`}
                                            >
                                              {heading.h4s.map((h4) => {
                                                const addSubSubNavCondClass = `${checkClass(
                                                  [
                                                    section,
                                                    decodeURIComponent(h4)
                                                  ]
                                                )} ${condClass} apiLink accordionDetailsStyle`;
                                                return createNavLink(
                                                  [
                                                    section,
                                                    decodeURIComponent(h4)
                                                  ],
                                                  openLinks[
                                                    openLinks?.length - 1
                                                  ] ===
                                                    decodeURIComponent(
                                                      cleanDetailsLink(h4)
                                                    ) ||
                                                    openLinks[
                                                    openLinks?.length - 2
                                                    ] ===
                                                    decodeURIComponent(
                                                      cleanDetailsLink(h4)
                                                    )
                                                    ? 'apiActive apiLink'
                                                    : addSubSubNavCondClass
                                                );
                                              })}
                                            </List>
                                          </Accordion>
                                        </li>
                                      );
                                    } else {
                                      return createNavLink(
                                        [
                                          section,
                                          decodeURIComponent(heading.h3?.trim())
                                        ],
                                        (openLinks[openLinks?.length - 1] ===
                                          decodeURIComponent(
                                            cleanDetailsLink(heading.h3?.trim())
                                          ) ||
                                          ([
                                            'latestrelease',
                                            'releasenotes'
                                          ].includes(
                                            openLinks[openLinks?.length - 1]
                                          ) &&
                                            decodeURIComponent(
                                              cleanDetailsLink(
                                                heading.h3?.trim()
                                              )
                                            ) ===
                                            decodeURIComponent(
                                              cleanDetailsLink(
                                                nestedHeadings[0].h3?.trim()
                                              )
                                            ))) &&
                                          !releaseNotesAccordionActive.length
                                          ? 'apiActive apiLink'
                                          : addSubNavCondClass
                                      );
                                    }
                                  })}
                                </List>
                              </Accordion>
                            </li>
                          );
                        } else {
                          //Link has no subnav
                          return createNavLink(
                            [section, link],
                            addNavCondClass
                          );
                        }
                      } catch {
                        console.log(
                          `Error creating left api nav on: ${section} / ${link}`
                        );
                        return false;
                      }
                    })}
                  </List>
                </AccordionDetails>
              </Accordion>
            );
          }
        })}
    </nav>
  );

  const getApiBodyHeaderBGStyles = (scrollPosition: number) => {
    const commonStyles = {
      '--top': `-${Math.min(128, 20 + scrollPosition)}px`,
      '--height': `${Math.min(128, 55 + scrollPosition)}px`
    } as React.CSSProperties;
    // Mobile: apply styles conditionally based on showFrDisclaimer
    if (mobile && !showFrDisclaimer) {
      return undefined;
    }
    // Non-mobile: apply styles regardless of showFrDisclaimer
    return commonStyles;
  };

  const getPaddingTop = (scrollPosition: number) => {
    return showFrDisclaimer
      ? `${Math.max(0, mobile ? 80 : 77 - scrollPosition)}px`
      : 0;
  };

  const findAndRemoveTabs = () => ({
    ...(t('api_documentation_tabs', { returnObjects: true, defaultValue: {} }) as {
      [key: string]: string;
    })
  });

  // Always derive the current route from the URL (the source of truth) rather
  // than the currLinks state. currLinks lags one render behind navigation (it
  // is updated by the url.pathname effect), so relying on it made the side-nav
  // drawer flash/stick on the roadmap page when the link was clicked while
  // currLinks still held the previous page's links.
  const roadmapLinks = url.pathname
    .split('/')
    .filter((link) => link !== 'api' && link !== i18n.language && link !== '');

  const isRoadmapRoute = roadmapLinks?.[0] === 'roadmap';
  const isDocRoute = roadmapLinks?.[0] === 'documentation' && roadmapLinks.length > 3;
  const isDocHomeRoute =
    roadmapLinks?.[0] === 'documentation' &&
    roadmapLinks.length <= 3 &&
    (!roadmapLinks[1] || roadmapLinks[1] === 'ndcapis');

  if (isRoadmapRoute) {
    // Roadmap (and its Quarter Details sub-page) render standalone: skip the
    // Api page wrapper/drawer/Main entirely so none of Api.scss / ApiJSON.scss
    // / GettingStartedOverview.scss or the persistent-drawer layout styles
    // apply — only AppRoadMap.scss / QuarterDetails.scss do.
    if (roadmapLinks.length >= 3 && roadmapLinks[1] && roadmapLinks[2]) {
      return <QuarterDetails year={roadmapLinks[1]} quarter={roadmapLinks[2]} />;
    }
    return <AppRoadMap />;
  }

  return (
    <div style={{ marginTop: isDocRoute ? 'inherit' : `${logoHeight}px` }}>
      <div aria-live="polite" aria-atomic="true" className="sr-only">
        {alertMessage}
      </div>
      <Box
        id={isDocRoute ? '' : "apiPage"}
        className={`${open ? 'apiNavigatorOpen' : 'apiNavigatorClosed'} ${mobile ? 'apiMobile' : ''
          } ${checkIfSpecialPg()} ${isDocHomeRoute ? 'docHomePg' : ''}`}
        display="flex"
      >
        <CssBaseline />
        {!(isRoadmapRoute || isDocRoute || isDocHomeRoute) && (
        <Box id="apiLeftNavWrap">
          <Box
            id="apiNavigatorBttnWrap"

            sx={{
              ...(mobile
                ? { top: `${logoHeight - (announcementBanner ? 35 : 10)}px` }
                : { top: `${logoHeight - (announcementBanner ? 25 : 5)}px` }),
              width: `calc(${drawerWidth}px - 42px)`,
              ...(open && { backgroundColor: 'white' })
            }}
          >
            <Button
              onClick={handleDrawerOpen}
              onKeyDown={handleKeyPressDrawer}
              size="medium"
              sx={{
                ...(open && { display: 'none' }), backgroundColor: 'none',
                '&:focus-visible': {
                  zIndex: 1,
                  outline: '2px solid black',
                  outlineOffset: '2px',
                }
              }}
              className="apiNavigatorBttns"
            >
              <KeyboardDoubleArrowRightIcon fontSize="medium" />
              {getShowHideBttnTxt('show')}
            </Button>
            <Button
              onClick={handleDrawerClose}
              onKeyDown={handleKeyPressDrawer}
              sx={{
                ...(!open && { display: 'none' }),
                '&:focus-visible': {
                  zIndex: 1,
                  outline: '2px solid black',
                  outlineOffset: '2px',
                }
              }}
              className="apiNavigatorBttns"
            >
              <KeyboardDoubleArrowLeftIcon fontSize="medium" />
              {getShowHideBttnTxt('hide')}
            </Button>
          </Box>

          <Drawer
            sx={{
              width: mobile ? (open ? drawerWidth : 0) : drawerWidth,
              flexShrink: 0,
              '& .MuiDrawer-paper': {
                width: drawerWidth,
                boxSizing: 'border-box',
                height: '80vh',
                overflow: 'auto'
              },
              zIndex: 4,
              position: 'relative'
            }}
            variant="persistent"
            anchor="left"
            open={open}
          >
            {data ? (
              drawer
            ) : (
              <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
            )}
          </Drawer>
        </Box>
        )}

        <Main
          className="apiMainContent"
          sx={isDocRoute ? {
            p: 0
          } : isDocHomeRoute ? {
            marginLeft: 0
          } : undefined}
          open={open}
          mobile={mobile}
          ref={mainRef}
          aria-labelledby="page-title"
        //tabIndex={0}
        >
          {currLinks?.[0] === 'roadmap' ? (
            content
          ) : currLinks?.[0] === 'documentation' &&
          currLinks?.length > 2 &&
          !nonStanApiRefSubs?.documentation?.[currLinks?.[2]] ? (
            <>
              {showFrDisclaimer && (
                <FrenchDisclaimer pageType="nonTab" open={open} />
              )}

              <Box
                className="apiMainContentContain apiTabsShowing"
                paddingTop={getPaddingTop(scrollPosition)}
              >
                {!selectedApiDocTab && <div className="apiBodyHeaderWrap">
                  <div
                    className="apiBodyHeaderBG"
                    style={getApiBodyHeaderBGStyles(scrollPosition)}
                  />
                  <Box
                    className={`apiBodyHeader ${mobile && showFrDisclaimer ? 'frDisclaimer' : ''
                      }`}
                    component="h1"
                    id='page-title'
                    ref={bodyHeader}
                    sx={{ fontSize: getHeaderFontSize(currLabel) }}
                  >
                    {currLabel}
                  </Box>
                </div>}

                {showAppLoader && <AppLoader />}

                {selectedApiDocTab && (
                  <ApiDocTabs
                    docs={apiDocTabsDocs}
                    tabs={findAndRemoveTabs()}
                    selectedTab={currLinks[2]}
                    setCurrLinks={setCurrLinks}
                    urlVersion={apiVersionNew ? '25.1' : '17.2'}
                    apiRouteSlug={currLinks[1]}
                  />
                )}
              </Box>
            </>
          ) : (
            <>
              {showFrDisclaimer && (
                <div>
                  <FrenchDisclaimer
                    open={open}
                    pageType={
                      currLinks && currLinks[1] !== 'ndcapis' ? '' : 'ndcAPIs'
                    }
                  />
                </div>
              )}
              <Box
                className="apiMainContentContain"
                paddingTop={
                  showFrDisclaimer
                    ? `${Math.max(0, 100 - scrollPosition)}px`
                    : 0
                }
              >
                <div className="apiBodyHeaderWrap">
                  <div
                    className="apiBodyHeaderBG"
                    style={
                      showFrDisclaimer
                        ? ({
                          '--top': `-${Math.min(128, 40 + scrollPosition)}px`,
                          '--height': `${Math.min(
                            128,
                            75 + scrollPosition
                          )}px`
                        } as CSSProperties)
                        : undefined
                    }
                  />
                  <Box
                    id="page-title"
                    className={`apiBodyHeader ${showFrDisclaimer && 'frDisclaimer'
                      }`}
                    component="h1"
                    ref={bodyHeader}
                    sx={{ fontSize: getHeaderFontSize(currLabel) }}
                  >
                    {currLabel}
                  </Box>
                </div>
                {showAppLoader && <AppLoader />}
                <Box sx={{ wordBreak: 'break-word' }}>{content}</Box>
              </Box>
            </>
          )}
        </Main>
      </Box>
    </div>
  );
}
